"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _cssClassesHelper = require("../../../helpers/cssClassesHelper");
var _withdrawHelper = require("../../../helpers/withdrawHelper");
var _FiatWithdraw = require("./FiatWithdraw");
var _FiatDeposit = require("./FiatDeposit");
var _FiatSidePaneHeaderComponent = _interopRequireDefault(require("./FiatSidePaneHeaderComponent"));
var _FiatFormTabsComponent = _interopRequireDefault(require("./FiatFormTabsComponent"));
require("./FiatSidePaneComponent.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var fiatSidePaneClasses = (0, _cssClassesHelper.getBEMClasses)('fiat-sidepane');
var FiatSidePaneComponent = /*#__PURE__*/function (_React$Component) {
  function FiatSidePaneComponent(props) {
    var _this;
    _classCallCheck(this, FiatSidePaneComponent);
    _this = _callSuper(this, FiatSidePaneComponent, [props]);
    _defineProperty(_this, "onTabChange", function () {
      _this.setState({
        isSend: !_this.state.isSend,
        data: {}
      });
    });
    _defineProperty(_this, "onUpdate", function () {
      _this.getWithdrawFee();
      _this.setTotal();
    });
    _defineProperty(_this, "setTotal", function () {
      var _this$props = _this.props,
        position = _this$props.position,
        fee = _this$props.fee;
      var Amount = _this.state.data.Amount;
      var amount = parseFloat(Amount);
      var balance = (0, _withdrawHelper.getAvailableBalance)(position === null || position === void 0 ? void 0 : position.Amount, position === null || position === void 0 ? void 0 : position.Hold);
      var total = 0;
      if (amount) {
        total = (0, _withdrawHelper.getFinalBalanceWithdrawValue)(balance, amount, fee);
      }
      _this.setState({
        total: total
      });
    });
    _defineProperty(_this, "getWithdrawFee", function () {
      var _this$props2 = _this.props,
        ProductId = _this$props2.product.ProductId,
        getWithdrawFee = _this$props2.getWithdrawFee,
        AccountProviderId = _this$props2.AccountProviderId;
      var Amount = _this.state.data.Amount;
      if (!isNaN(Amount)) {
        getWithdrawFee(ProductId, Amount, AccountProviderId);
      }
    });
    _defineProperty(_this, "onDataUpdate", function (data) {
      var _this$state = _this.state,
        Amount = _this$state.data.Amount,
        isSend = _this$state.isSend;
      _this.setState({
        data: data
      }, function () {
        if (!isSend && data.Amount !== Amount) {
          _this.onUpdate();
        }
      });
    });
    _defineProperty(_this, "renderInstructions", function (modificator) {
      var t = _this.props.t;
      return /*#__PURE__*/_react["default"].createElement("section", {
        className: fiatSidePaneClasses('side-details', modificator)
      }, /*#__PURE__*/_react["default"].createElement("header", {
        className: fiatSidePaneClasses('instructions-header', modificator)
      }, t('Instructions')), /*#__PURE__*/_react["default"].createElement("section", {
        className: fiatSidePaneClasses('address-instructions', modificator)
      }, /*#__PURE__*/_react["default"].createElement("div", null, t("Step 1: Create the deposit ticket.")), /*#__PURE__*/_react["default"].createElement("div", null, t("Step 2: Process deposit instructions on the deposit receipt."))));
    });
    _this.state = {
      isSend: props.isSend,
      data: {},
      openConfirmModal: false
    };
    return _this;
  }
  _inherits(FiatSidePaneComponent, _React$Component);
  return _createClass(FiatSidePaneComponent, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.onSidePaneOpen({
        customClass: this.props.showDetails ? 'retail-sidepane-with-details' : 'retail-sidepane',
        classModifiers: 'with-tabs',
        hideHeader: true
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
        TicketAmount = _this$props3.TicketAmount,
        product = _this$props3.product,
        position = _this$props3.position,
        fee = _this$props3.fee,
        showDetails = _this$props3.showDetails,
        productConfig = _this$props3.productConfig,
        withdrawDetailsInfo = _this$props3.withdrawDetailsInfo,
        isDepositDisabled = _this$props3.isDepositDisabled,
        isWithdrawDisabled = _this$props3.isWithdrawDisabled;
      var _this$state2 = this.state,
        isSend = _this$state2.isSend,
        data = _this$state2.data,
        total = _this$state2.total;
      var balance = (0, _withdrawHelper.getAvailableBalance)(position === null || position === void 0 ? void 0 : position.Amount, position === null || position === void 0 ? void 0 : position.Hold);
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: fiatSidePaneClasses()
      }, /*#__PURE__*/_react["default"].createElement("section", {
        className: fiatSidePaneClasses('main')
      }, /*#__PURE__*/_react["default"].createElement(_FiatSidePaneHeaderComponent["default"], {
        product: product
      }), /*#__PURE__*/_react["default"].createElement("section", {
        className: fiatSidePaneClasses('main-form')
      }, /*#__PURE__*/_react["default"].createElement(_FiatFormTabsComponent["default"], {
        isSend: isSend,
        toggleTab: this.onTabChange,
        product: product,
        balance: balance,
        isDepositDisabled: isDepositDisabled,
        isWithdrawDisabled: isWithdrawDisabled
      }), isSend ? /*#__PURE__*/_react["default"].createElement(_FiatDeposit.FiatDepositFormContainer, {
        product: product,
        onChange: this.onDataUpdate
      }) : /*#__PURE__*/_react["default"].createElement(_FiatWithdraw.FiatWithdrawFormContainer, {
        product: product,
        balance: balance,
        fee: fee,
        total: total,
        onChange: this.onDataUpdate,
        showDetails: showDetails
      })), isSend && !showDetails ? this.renderInstructions('no-details') : null), showDetails && /*#__PURE__*/_react["default"].createElement("section", {
        className: fiatSidePaneClasses('side')
      }, isSend ? /*#__PURE__*/_react["default"].createElement(_FiatDeposit.FiatDepositDetailsComponent, {
        info: productConfig.instructions
      }) : /*#__PURE__*/_react["default"].createElement(_FiatWithdraw.FiatWithdrawDetailsComponent, {
        TicketAmount: TicketAmount,
        data: data,
        fee: fee,
        product: product,
        balance: balance,
        detailsInfo: withdrawDetailsInfo
      })), /*#__PURE__*/_react["default"].createElement(_FiatDeposit.FiatDepositModalContainer, null), /*#__PURE__*/_react["default"].createElement(_FiatWithdraw.FiatWithdrawModalContainer, {
        TicketAmount: TicketAmount
      }));
    }
  }]);
}(_react["default"].Component);
FiatSidePaneComponent.defaultProps = {
  showDetails: true,
  onSidePaneOpen: function onSidePaneOpen() {},
  isSend: true
};
var _default = exports["default"] = (0, _reactI18next.withTranslation)('core')(FiatSidePaneComponent);